import { alpha, InputLabel, Select, SelectProps, styled } from '@mui/material';
import React from 'react';

interface RedditSelectProps extends SelectProps {
    inputId?: string;
    inputLabelText?: string;
}

export const RedditSelect = styled((props: RedditSelectProps) => {
    return (
        <>
            <InputLabel
                sx={{
                    color: '#8f8f8f !important',
                    lineHeight: '30px',
                    fontSize: '2.25rem',
                    paddingBottom: '5px',
                }}
                id={props.inputId}
            >
                {props.inputLabelText}
            </InputLabel>
            <Select {...props} />
        </>
    );
})(({ theme }) => ({
    '& .MuiInputBase-root': {
        backgroundColor: '#ffffff !impotant',
    },
    '& .MuiSelect-filled': {
        lineHeight: '65px',
        height: '65px',
        fontSize: '2.25rem',
        border: `1px solid ${theme.palette.secondary.main}`,
        overflow: 'hidden',
        color: '#222222',
        borderRadius: 4,
        backgroundColor: '#ffffff',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&.Mui-focused': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
            borderColor: theme.palette.primary.main,
            backgroundColor: '#ffffff',
        },
        '&:hover': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
            borderColor: theme.palette.primary.main,
            backgroundColor: '#ffffff',
        },
    },
}));
